import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DataService } from '../../../data.service';
import { ApiService } from '../../../shared/api.service';
import { DefaultService } from '../../../utils/default.service';
import { TableSchema } from '../../../utils/table-schema';
import { CcassService } from '../../ccass.service';
import { SIDE_NAVE_TITLES } from '../../utils/util-constants';

@Component({
  selector: 'app-pd',
  templateUrl: './pd.component.html',
  styleUrls: ['./pd.component.scss']
})
export class PdComponent implements OnInit {

  pageTitle: string = SIDE_NAVE_TITLES.participantDealer;

  @Output() titleHeading = new EventEmitter<string>();
  @Output() shouldDisplayTitle = new EventEmitter<boolean>();

  tableColumns = TableSchema['participating-dealer'];
  loading = false;

  particpateDealerData: any = [];
  selectedRow: any;
  setDialogName: string;
  btnName: string;
  viewAddPd: boolean;
  headerSelectOptions: any = {}
  currentRow: any;
  onClickDelete: boolean;
  setIndex: any;
  showAlertPopup = false
  message: string;

  constructor(
    private ccassService: CcassService,
    private apiService: ApiService,
    private defaultService: DefaultService,
    private messageService: MessageService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.titleHeading.emit(this.pageTitle);
    this.shouldDisplayTitle.emit(false);
    this.getPdData()
  }

  getPdData() {
    const url = 'v1/participants'
    this.ccassService.ccassfindOne('', url).then(response => {
      if (response['status'] && response['status'] === 'success') {
        if(response['participants'] && response['participants'] !== null) {
          this.particpateDealerData = response['participants'];
          this.setHeaderSelectOptions(response['participants'])
        } else {
          this.particpateDealerData = []
          this.setHeaderSelectOptions([])
        }
      } else {
        this.messageService.add({ severity: 'error', detail: response['status'] });
        this.loading = false;
        // handle failure
      }
    }).catch(err => {
      if (err.status == 500) {
        this.messageService.add({ severity: 'error', detail: err['statusText'] ? err['statusText'] : 'Internal server error' });
      }
      else if (err.status == 502) {
        this.messageService.add({ severity: 'error', detail: err.status ? err.status + 'Bad Gateway' : '502 Bad Gateway' });
      } else {
        this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      }
      this.loading = false;
      // handle error
    });
  }

  onAddPd() {
    this.selectedRow = undefined;
    this.setDialogName = 'ADD';
    this.btnName = 'SAVE';
    this.viewAddPd = true;
  }

  editPd(event: any) {
    this.selectedRow = event['row'];
    this.setDialogName = 'EDIT';
    this.btnName = 'UPDATE';
    this.viewAddPd = true;
  }

  deletePd(event: any) {
    this.currentRow = event.row;
    this.onClickDelete = true;
    this.selectedRow = event.row;
    this.setIndex = event.index;
  }

  setHeaderSelectOptions(data: any) {
    let pdOptions = [{ label: 'All', value: null }]
    let nationalityOptions = [{ label: 'All', value: null }]
    if (data.length > 0) {
      data?.forEach((d: any) => {
        if (d.participantName) { pdOptions.push({ label: d.participantName, value: d.participantName }); }
        if (d.nationalityDesc) { nationalityOptions.push({ label: d.nationalityDesc, value: d.nationalityDesc }); }
      })
      const uniquePdOptions = [...new Set(pdOptions.map(item => item.label))];
      const uniqueNationalityOptions = [...new Set(nationalityOptions.map(item => item.label))];
      pdOptions = []; nationalityOptions = [];
      uniquePdOptions?.forEach((element: any) => pdOptions.push({ label: element, value: element == 'All' ? null : element }));
      uniqueNationalityOptions?.forEach((element: any) => nationalityOptions.push({ label: element, value: element == 'All' ? null : element }));
      this.headerSelectOptions['participantName'] = pdOptions;
      this.headerSelectOptions['nationalityDesc'] = nationalityOptions;
      this.loading = false
    } else {
      this.headerSelectOptions['participantName'] = pdOptions;
      this.headerSelectOptions['nationalityDesc'] = nationalityOptions;
      this.loading = false
    }
  }

  onClickYes() {
    const url = 'v1/participants/delete'
    this.ccassService.delete(this.selectedRow['id'], url).then(data => {
      if (data['status'] === 'success') {
        const message = data['message']
        this.shoeerrorpopup({message})
      } else {
        this.messageService.add({ severity: 'error', detail: data['message'] ? data['message'] : data['status'] });
        this.loading = false;
      }
    }).catch(err => {
      this.messageService.add({ severity: 'error', detail: typeof err === 'object' ? err['statusText'] : err });
      this.loading = false;
    })
  }

  shoeerrorpopup(event:any) {
    this.showAlertPopup = true
    this.message = event.message
  }

  onClickok() {
    this.getPdData()
  }

}
